/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Invoice_VatInputs */

const en_inbound_field_invoice_vat = /** @type {(inputs: Inbound_Field_Invoice_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice VAT`)
};

/**
* | output |
* | --- |
* | "Invoice VAT" |
*
* @param {Inbound_Field_Invoice_VatInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_invoice_vat = /** @type {((inputs?: Inbound_Field_Invoice_VatInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Invoice_VatInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_invoice_vat(inputs)
});